import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "file-item"
}
const _hoisted_2 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SampleItem = _resolveComponent("SampleItem")
  const _component_FileIcon = _resolveComponent("FileIcon")
  const _component_Icon = _resolveComponent("Icon")

  return ($props.mode === 'inline-text')
    ? (_openBlock(), _createBlock(_component_SampleItem, {
        key: 0,
        file: $props.file
      }, null, 8 /* PROPS */, ["file"]))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_FileIcon, {
          error: $props.file.failed,
          ext: $props.file.ext,
          class: "icon",
          pulse: $props.file.processing,
          disabled: $props.file.removing
        }, null, 8 /* PROPS */, ["error", "ext", "pulse", "disabled"]),
        _createElementVNode("div", {
          class: "text",
          disabled: $props.file.removing
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["name", {'failed': $props.file.failed}])
          }, _toDisplayString($props.file.name), 3 /* TEXT, CLASS */),
          _createElementVNode("div", {
            class: _normalizeClass(["size", {'failed': $props.file.failed}])
          }, _toDisplayString(_ctx.$utils.format.bytes($props.file.size)), 3 /* TEXT, CLASS */)
        ], 8 /* PROPS */, _hoisted_2),
        _createVNode(_component_Icon, {
          icon: "download-02",
          class: "pointer",
          width: "2rem",
          height: "2rem",
          stroke: "var(--gray-600)",
          onClick: _cache[0] || (_cache[0] = _withModifiers($event => (_ctx.$emit('download', $props.file.id)), ["stop"]))
        }),
        _createVNode(_component_Icon, {
          class: "pointer",
          width: "2rem",
          height: "2rem",
          icon: "trash-04",
          stroke: "var(--gray-500)",
          disabled: $props.file.removing,
          onClick: _cache[1] || (_cache[1] = _withModifiers($event => (_ctx.$emit('delete', $props.file.id)), ["stop"]))
        }, null, 8 /* PROPS */, ["disabled"])
      ]))
}